import React from 'react'
import Mantenimiento from '../componets/Mantenimiento'

function NoPage() {
  return (


    <>
      {/* <div style={{ height: 'calc(90vh)', display: 'flex', justifyContent: "center", alignItems: "center" }} className='container'>
        <div>
          <h1 className='mt-5'>!Disculpe las molestias! </h1>
          <h2>Tenemos problemas con nuestro servicio, intente más tarde... </h2>
        </div>
      </div> */}
      <Mantenimiento></Mantenimiento>
    </>
  )
}

export default NoPage